import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import EmployeeSectionComp from './EmployeeSectionComp';

function EmployeeSectionPage({ section }) {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <EmployeeSectionComp section={section} />
      </div>
    </div>
  );
}

export default EmployeeSectionPage;
